/** @format */

import { useState, useEffect, useRef } from "react";

export function useMeasure<T extends Element, P extends Array<any> = []>(callback?: (rect: DOMRectReadOnly, ...props: P) => void, ...props: P) {
  const ref = useRef<T>(null);
  const [bounds, set] = useState({ left: 0, top: 0, width: 0, height: 0 });
  const [ro] = useState(
    () => new ResizeObserver(([entry]) => {
      callback?.(entry.contentRect, ...props)
      set(entry.contentRect)
    })
  );
  useEffect(() => {
    setTimeout(() => {
      if (ref.current) {
        set(ref.current.getBoundingClientRect())
        ro.observe(ref.current);
      }
    })
    return () => ro.disconnect();
  }, []);
  return [{ ref }, bounds] as const;
}
